// subscriptionUtils.js

export const executeSubscriptionAction = async (endpoint) => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const subsId = urlParams.get("id");

    const codeParam = `${process.env.REACT_APP_VR_WEB_HOOK_TOKEN}`;
    const fullUrl = `${endpoint}?code=${codeParam}`;

    const response = await fetch(fullUrl, {
      method: "POST",
      headers: {
        "subscription-id": subsId,
        "Content-Type": "application/json",
      },
    });

    // If response is not ok, create an error with detailed information
    if (!response.ok) {
      const errorBody = await response.text();
      const error = new Error("Subscription Action Failed");
      error.status = response.status;
      error.statusText = response.statusText;
      error.response = response;
      error.responseBody = errorBody;
      
      throw error;
    }

    const data = await response.json();      
    console.log(data);
    return data;
  } catch (error) {
    console.error("Subscription Action Error:", error);
    throw error;
  }
};

export const activateSubscription = async() => {
  const activateEndpoint = `${process.env.REACT_APP_VR_WEB_HOOK_URL}/activatesubscription`;
  const response = await executeSubscriptionAction(activateEndpoint);
  return response;
};

export const cancelSubscription = async () => {
  const cancelEndpoint = `${process.env.REACT_APP_VR_WEB_HOOK_URL}/cancelsubscription`;
  await executeSubscriptionAction(cancelEndpoint);
};

export const checkSubscriptionStatus = async () => {
  const statusEndpoint = `${process.env.REACT_APP_VR_WEB_HOOK_URL}/checksubscriptionstatus`;
  await executeSubscriptionAction(statusEndpoint);
};